import React, { useState, useEffect } from "react";
import { useHistory } from "react-router";
import { Button, TextField, Typography } from "@mui/material";
import moment from "moment";

import CreatableSelect from "react-select/creatable";

import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

import { DatePicker } from "@mui/x-date-pickers/DatePicker";

import Swal from "sweetalert2";
import Toast from "../../utils/Toast";

import useCreateAudit from "../../mutation/audit/createAudit";

import useProperty from "../../queries/property/getProperties";
import {
  FormPageShell,
  FormPageCard,
  FormPageHeader,
  FormActions,
} from "../../components/ListPage";

const schema = yup.object().shape({
  name: yup.string().required("Name is required"),
  code: yup.string().required("Code is required"),
  startDate: yup.date().required("Start Date is required"),
  endDate: yup.date().required("End Date is required"),
  prop: yup.object().required("A property must be selected."),
});

const NewRateNumber = (props) => {
  const history = useHistory();

  const [propertyResponse, setPropertiesResponse] = useProperty();

  const [auditResponse, setAuditData] = useCreateAudit();
  const [startDate, setStartDate] = useState(moment());
  const [endDate, setEndDate] = useState(moment());

  const [propertyOptions, setPropertyOptions] = useState([]);

  const propertyChange = (value) => {
    setValue("prop", value);
  };

  const { control, register, handleSubmit, setValue, errors } = useForm({
    resolver: yupResolver(schema),
  });

  useEffect(() => {
    console.log(errors);
  }, [errors]);

  useEffect(() => {
    if (propertyResponse.data) {
      //setup options
      let data = propertyResponse.data;
      let propertyOptions = [];
      for (var i = 0; i < data.length; i++) {
        let property = data[i];
        propertyOptions.push({
          label: property.name,
          value: property.id,
        });
      }

      setPropertyOptions(propertyOptions);
    }
  }, [propertyResponse]);

  const goBack = () => {
    window.location.href = "/dashboard/rate-numbers";
  };

  const handleStartDateChange = (value) => {
    setStartDate(value);
    setValue("startDate", value.toDate());
  };
  const handleEndDateChange = (value) => {
    setEndDate(value);
    setValue("endDate", value.toDate());
  };

  const onSubmit = (values) => {
    console.log(values);
    values.startDate = moment(values.startDate).endOf("day");
    values.endDate = moment(values.endDate).endOf("day");
    values.prop = values.prop.value;

    Swal.fire({
      title: "Create Updates",
      html: `<h4>Please provide a description before submitting your changes</h4>
            <textarea maxlength="100" type="text" id="actionDescription" class="swal2-input" placeholder="Description" font-size=18px style="height:auto!important" rows=5>`,
      confirmButtonText: "Confirm",
      focusConfirm: false,
      preConfirm: () => {
        const actionDescription =
          Swal.getPopup().querySelector("#actionDescription").value;
        if (!actionDescription) {
          Swal.showValidationMessage(`Please enter description`);
        }
        return {
          actionDescription: actionDescription,
          newData: values,
          type: "rate-number",
          action: "create",
        };
      },
    }).then((result) => {
      if (result.isConfirmed) {
        setAuditData(result.value);
      }
    });
  };

  useEffect(() => {
    try {
      if (auditResponse.data) {
        Toast.fire({
          icon: "success",
          title: "Rate Number created",
        });
        history.push("/dashboard/rate-numbers");
      } else if (auditResponse.error) {
        let data = auditResponse.errorMessage.response.data;
        if (data) {
          let messageData = data.message;
          let message = messageData.message;

          if (message == "Dates Unavailable") {
            Swal.fire({
              icon: "error",
              title: "Error",
              text: "The time period for the Rate number overlaps with an existing rate number. Please change the time period.",
            });
          } else {
            Swal.fire({
              icon: "error",
              title: "Error",
              text: message,
            });
          }
        } else {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: auditResponse.error.message,
          });
        }
      }
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: err.message,
      });
    }
  }, [auditResponse]);

  const renderContent = () => {
    return (
      <FormPageShell>
        <form noValidate onSubmit={handleSubmit(onSubmit)}>
          <FormPageCard>
            <FormPageHeader
              title="New Rate Number"
              onBack={goBack}
              subtitle="Please fill in the required fields."
            />
            <TextField
              name="name"
              margin="normal"
              fullWidth
              label="Name*"
              variant="outlined"
              inputRef={register}
              error={errors.name != null}
              helperText={errors.name != null ? errors.name.message : null}
              disabled={auditResponse.loading}
            />
            <TextField
              name="code"
              margin="normal"
              fullWidth
              label="Code*"
              variant="outlined"
              inputRef={register}
              error={errors.code != null}
              helperText={errors.code != null ? errors.code.message : null}
              disabled={auditResponse.loading}
            />
            <Controller
              name="startDate"
              control={control}
              defaultValue={startDate}
              render={({ ...props }) => {
                return (
                  <DatePicker
                    label="Start Date*"
                    value={startDate}
                    onChange={handleStartDateChange}
                    format="DD/MM/YYYY"
                    maxDate={endDate}
                    disabled={auditResponse.loading}
                    slotProps={{
                      textField: {
                        variant: "outlined",
                        fullWidth: true,
                        margin: "normal",
                        error: errors.startDate != null,
                        helperText:
                          errors.startDate != null
                            ? errors.startDate.message
                            : null,
                      },
                    }}
                  />
                );
              }}
            />
            <Controller
              name="endDate"
              control={control}
              defaultValue={endDate}
              render={({ ...props }) => {
                return (
                  <DatePicker
                    label="End Date*"
                    value={endDate}
                    onChange={handleEndDateChange}
                    format="DD/MM/YYYY"
                    minDate={startDate}
                    disabled={auditResponse.loading}
                    slotProps={{
                      textField: {
                        variant: "outlined",
                        fullWidth: true,
                        margin: "normal",
                        error: errors.endDate != null,
                        helperText:
                          errors.endDate != null
                            ? errors.endDate.message
                            : null,
                      },
                    }}
                  />
                );
              }}
            />
            {propertyOptions.length > 0 && (
              <div>
                <Typography sx={{ fontSize: 16, fontWeight: "bold", mt: 1 }}>
                  Property
                </Typography>
                <div>
                  <Controller
                    name="prop"
                    control={control}
                    render={({ ...props }) => {
                      return (
                        <CreatableSelect
                          styles={{
                            control: (provided, state) => ({
                              ...provided,
                              borderColor: errors.room_types
                                ? "red"
                                : provided.borderColor,
                            }),
                          }}
                          options={propertyOptions}
                          onChange={propertyChange}
                          disabled={auditResponse.loading}
                        />
                      );
                    }}
                  />
                  {errors.properties && (
                    <div>{errors.properties.message}</div>
                  )}
                </div>
              </div>
            )}
          </FormPageCard>
          <FormPageCard sx={{ mt: 2 }}>
            <FormActions>
              <Button
                type="submit"
                size="large"
                variant="contained"
                color="primary"
                disabled={auditResponse.loading}
              >
                Submit
              </Button>
            </FormActions>
          </FormPageCard>
        </form>
      </FormPageShell>
    );
  };

  return (
    !propertyResponse.loading && !propertyResponse.loading && renderContent()
  );
};

export default NewRateNumber;
